import { useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Send } from "lucide-react";
import { lcall } from "@/lib/letters";
import { PagesView } from "@/components/letters/useLetterOutput";

export function PreviewDialog({ open, onOpenChange, pages }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[94vh] overflow-y-auto bg-slate-200" data-testid="preview-dialog">
        <DialogHeader><DialogTitle className="font-head">Aperçu — document final A4 ({pages?.length || 0} page(s))</DialogTitle></DialogHeader>
        {pages ? <PagesView pages={pages} /> : <p className="text-sm p-6 text-center">Mise en page…</p>}
        <DialogFooter><Button onClick={() => onOpenChange(false)} className="bg-brand-600 text-white" data-testid="preview-back">Revenir à l'éditeur</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function SendDialog({ open, onOpenChange, letter, output, onSent }) {
  const [f, setF] = useState({ to: letter.email || "", subject: `${letter.objet} — Réf. ${letter.reference}`, message: "Madame, Monsieur,\n\nVeuillez trouver ci-joint notre courrier.\n\nCordialement.", joindre_pieces: true });
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    const pdf_base64 = await output.base64();
    const r = await lcall(() => api.post(`/letters/${letter.id}/send-email`, { ...f, pdf_base64 }), "Courrier envoyé par e-mail");
    setBusy(false);
    if (r) { onOpenChange(false); onSent(r); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="send-dialog">
        <DialogHeader><DialogTitle className="font-head">Envoyer par e-mail</DialogTitle></DialogHeader>
        <label className="text-xs">Destinataire<Input value={f.to} onChange={(e) => setF({ ...f, to: e.target.value })} data-testid="send-to" /></label>
        <label className="text-xs">Objet de l'e-mail<Input value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} data-testid="send-subject" /></label>
        <label className="text-xs">Message<Textarea rows={5} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="send-message" /></label>
        <label className="text-xs flex items-center gap-2"><input type="checkbox" checked={f.joindre_pieces} onChange={(e) => setF({ ...f, joindre_pieces: e.target.checked })} />Joindre aussi les pièces jointes du courrier</label>
        <p className="text-[11px] text-slate-500">Le PDF du courrier est joint automatiquement. Le courrier passera au statut ENVOYÉ et sera inscrit dans les courriers envoyés.</p>
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button className="bg-brand-600 text-white" onClick={send} disabled={busy || !f.to} data-testid="send-submit">{busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Send className="h-4 w-4 mr-1" />}Envoyer</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
